// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "header a.nuxt-link-exact-active[data-v-544bf58e]{--tw-text-opacity:1;color:#0d6e9c;color:rgba(13,110,156,var(--tw-text-opacity))}.phone-short[data-v-544bf58e]{display:none}@media(max-width:407px){.menu-text[data-v-544bf58e]{display:none}.phone-short[data-v-544bf58e]{display:block}.phone-full[data-v-544bf58e]{display:none}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
